/* Back-in-stock ("Thông báo khi có hàng") — PDP.
 *
 * Shows the CTA only while the SELECTED variant is unavailable and keeps the modal
 * copy + hidden fields pointed at that exact variant.
 *
 * Two submit paths. With [data-endpoint] it POSTs JSON over fetch and confirms in
 * place. Without one, the native {% form 'customer' %} MUST submit natively —
 * storefront bot protection rejects a fetch of the same body with 400 "Missing
 * CAPTCHA token", since Shopify's captcha script only tokenises a real submission.
 * That redirect drops ?variant=, so the variant + email are stashed in
 * sessionStorage and the confirmation is restored from them after the reload.
 */
(function () {
  'use strict';

  // Copy comes from window.yslI18n (rendered by snippets/ysl-i18n-js.liquid) because a
  // .js asset cannot run Liquid's `t` filter. The literal stays as the fallback, so a
  // missing key degrades to the Vietnamese copy instead of to an empty string.
  function T(k, fallback) { var d = window.yslI18n; return (d && d[k]) || fallback; }

  function init(root) {
    if (root.dataset.bisReady) return;
    root.dataset.bisReady = '1';

    var endpoint = root.dataset.endpoint || '';
    var modal = root.querySelector('[data-bis-modal]');
    var openBtn = root.querySelector('[data-bis-open]');
    var done = root.querySelector('[data-bis-done]');
    var doneVariant = root.querySelector('[data-bis-done-variant]');
    var form = root.querySelector('[data-bis-form]');            // endpoint path
    var cform = root.querySelector('form.ysl-bis__cform');        // native customer form
    var err = root.querySelector('[data-bis-err]');
    var consent = root.querySelector('[data-bis-consent]');
    var emailEl = root.querySelector('[data-bis-email]');
    var phoneEl = root.querySelector('[data-bis-phone]');
    var img = root.querySelector('[data-bis-img]');
    var vLabel = root.querySelector('[data-bis-variant]');
    var sub = root.querySelector('[data-bis-sub]');
    var ok = root.querySelector('[data-bis-ok]');
    var okEmail = root.querySelector('[data-bis-ok-email]');
    var okVariant = root.querySelector('[data-bis-ok-variant]');
    var active = form || cform;

    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-bis-variants]').textContent) || [];
    } catch (e) { variants = []; }

    // variant ids already subscribed — keeps the CTA from inviting a duplicate signup.
    // Seeded from the logged-in customer's own bis-<id> tags, so it holds across devices;
    // a guest only gets the ones they just submitted in this tab.
    var subscribed = {};
    (root.dataset.subscribed || '').split(',').forEach(function (id) {
      if (id) subscribed[id] = true;
    });

    function current() {
      var id = String(root.dataset.variantId || '');
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === id) return variants[i];
      }
      return null;
    }

    function paint() {
      var v = current();
      var oos = !!v && v.available === false;
      root.hidden = !oos;
      if (oos) root.setAttribute('data-oos', ''); else root.removeAttribute('data-oos');
      if (!v) return;
      if (vLabel) vLabel.textContent = v.label || v.title || '';
      if (img && v.img) img.src = v.img;
      // customer-form fallback: the tag IS the waitlist, so it must track the variant
      set('[data-bis-ctags]', 'bis,bis-' + v.id);
      var isDone = !!subscribed[String(v.id)];
      if (done) done.hidden = !isDone;
      if (doneVariant) doneVariant.textContent = v.label || v.title || '';
      if (openBtn) openBtn.hidden = isDone;
    }

    function set(sel, val) {
      var el = root.querySelector(sel);
      if (el) el.value = val == null ? '' : String(val);
    }

    // swap the form for the confirmation, or back again for a fresh variant
    function showOk(state, email, variantTitle) {
      if (!ok) return;
      ok.hidden = !state;
      if (active) active.hidden = state;
      if (sub) sub.hidden = state;
      if (!state) return;
      if (okEmail) okEmail.textContent = email || '';
      if (okVariant) okVariant.textContent = variantTitle || '';
    }

    function open(state) {
      if (!modal) return;
      modal.hidden = !state;
      document.documentElement.style.overflow = state ? 'hidden' : '';
      if (state) {
        showErr('');
        var v = current();
        showOk(!!(v && subscribed[String(v.id)]), emailEl && emailEl.value, v && (v.label || v.title));
        var first = modal.querySelector('input[type="email"]');
        if (first && !first.closest('[hidden]')) setTimeout(function () { first.focus(); }, 30);
      }
    }

    function showErr(msg) {
      if (!err) return;
      err.textContent = msg || '';
      err.hidden = !msg;
    }

    // Shared client-side gate. Phone is the required identifier; email is optional and
    // only checked when the shopper actually typed one. Returns the pair, or null.
    function validate() {
      var email = ((emailEl || {}).value || '').trim();
      var phoneRaw = ((phoneEl || {}).value || '').trim();
      var phone = phoneRaw.replace(/\D/g, '');
      // VN: 10 digits starting 0, or the same number carrying the 84 country code.
      if (!/^(0\d{9}|84\d{9})$/.test(phone)) { showErr(T('bisErrPhone', 'Số điện thoại chưa hợp lệ.')); return null; }
      // The no-endpoint fallback posts {% form 'customer' %}, and Shopify will not create
      // a contact without an address — so on that path email stays mandatory no matter
      // what the labels say. Phone-only signups need the endpoint.
      if (email && !/^[^@\s]+@[^@\s.]+\.[^@\s]+$/.test(email)) { showErr(T('bisErrEmail', 'Email chưa hợp lệ.')); return null; }
      if (consent && !consent.checked) { showErr(T('bisErrConsent', 'Vui lòng đồng ý nhận thông báo.')); return null; }
      var hp = root.querySelector('[data-bis-hp]');
      if (hp && hp.value) return null; // bot
      showErr('');
      return { email: email, phone: phone };
    }

    function busy(state, label) {
      var btn = (active && active.querySelector('[type="submit"]')) || null;
      if (!btn) return;
      if (state) {
        if (label) { btn.dataset.idle = btn.dataset.idle || btn.textContent; btn.textContent = label; }
        btn.setAttribute('aria-busy', 'true');
      } else {
        if (btn.dataset.idle) btn.textContent = btn.dataset.idle;
        btn.removeAttribute('aria-busy');
      }
    }

    // Email delivery runs on Klaviyo's native back-in-stock: one client call per signup,
    // Klaviyo watches the Shopify catalog inventory and its Back in Stock flow sends the
    // mail. The customer tags below stay the waitlist for the ZNS/SMS leg (phone only).
    // keepalive: the native customer form navigates right after this fires.
    var KEY = root.dataset.klaviyoKey || '';
    function klaviyoSubscribe(email, vid) {
      if (!KEY || !email || !vid || !window.fetch) return;
      try {
        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(KEY), {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({ data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } } }
          } })
        }).catch(function () { /* the Shopify waitlist still records the signup */ });
      } catch (e) { /* same */ }
    }

    function succeed(email) {
      var v = current();
      if (v) subscribed[String(v.id)] = true;
      showOk(true, email, v && (v.label || v.title));
      paint();
    }

    if (openBtn) openBtn.addEventListener('click', function () { open(true); });
    root.querySelectorAll('[data-bis-close]').forEach(function (x) {
      x.addEventListener('click', function () { open(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) open(false);
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = current();
        var who = validate();
        if (!v || !who) return;
        busy(true);
        klaviyoSubscribe(who.email, v.id);

        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            shop: (window.Shopify && window.Shopify.shop) || location.host,
            product_id: root.dataset.productId,
            product_title: root.dataset.productTitle,
            product_handle: root.dataset.productHandle,
            variant_id: String(v.id),
            variant_title: v.title || '',
            sku: v.sku || '',
            email: who.email,          // optional
            phone: who.phone,          // required identifier, still UNVERIFIED
            locale: (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'vi',
            url: location.href
          })
        })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); })
          .then(function () { succeed(who.email || who.phone); })
          .catch(function () { showErr(T('bisErrSend', 'Không gửi được, vui lòng thử lại sau ít phút.')); })
          .then(function () { busy(false); });
      });
    }

    // The native form must submit natively: the storefront has bot protection on, and
    // Shopify's captcha script only attaches its token to a real form submission —
    // posting the same FormData over fetch answers 400 "Missing CAPTCHA token".
    // So validate, stash what the reload will lose, and let the browser navigate.
    var PENDING = 'ysl-bis-pending';
    if (cform) {
      // Submits natively, and must: bot protection only tokenises a real submission, and a
      // challenge page has to be somewhere the shopper can actually see and solve it.
      // Posting into a hidden frame was tried and rejected — the POST came back as
      // /challenge inside the frame, no customer created, with nothing to show the shopper.
      // The page therefore reloads; stash what that reload destroys.
      cform.addEventListener('submit', function (e) {
        var who = validate();
        if (!who) { e.preventDefault(); return; }
        var v = current();
        // Shopify needs an address to create the contact. No email given → the account
        // IdP's own stand-in (84… @ synth domain), tagged so email senders skip it.
        var intl = who.phone.charAt(0) === '0' ? '84' + who.phone.slice(1) : who.phone;
        var synth = !who.email;
        klaviyoSubscribe(who.email, v && v.id);
        set('[data-bis-cemail-out]', who.email || (intl + '@' + (root.dataset.synthDomain || 'acct.yslbeauty.com.vn')));
        // phone survives only as a tag — the form drops contact[phone] and contact[note]
        set('[data-bis-ctags]', 'bis,bis-' + (v && v.id) + ',sdt-' + who.phone + (synth ? ',synth-email' : ''));
        try {
          sessionStorage.setItem(PENDING, JSON.stringify({
            vid: v && String(v.id), title: v && (v.label || v.title), email: who.email || who.phone
          }));
        } catch (err) { /* private mode: the confirmation degrades, the signup still lands */ }
        busy(true, T('bisSending', 'Đang gửi…'));
        // the captcha check can hold the submit for a beat; don't leave a dead button if it fails
        setTimeout(function () { busy(false); }, 8000);
      });
    }

    // PDP dispatches this on every variant change (ysl-pdp.liquid → selectVariant)
    document.addEventListener('ysl:variant', function (e) {
      if (!e.detail || !e.detail.variantId) return;
      root.dataset.variantId = String(e.detail.variantId);
      if (modal && !modal.hidden) open(false);
      showOk(false);
      paint();
    });

    paint();

    // Coming back from that native post: Shopify redirects to <page>?contact_posted=true#<form id>
    // and DROPS ?variant=, so the page reopens on another variant. `form.posted_successfully?`
    // is page-wide too (the footer form would light it up), hence the hash — only our form's
    // id produces it — plus the stashed variant, which is the only record of what was signed up.
    // {% form 'customer' %} answers with customer_posted=true; 'contact' answers with
    // contact_posted=true. Accept both — the hash is what proves it was OUR form.
    var posted = location.hash === '#ysl_bis_form' && /[?&](customer|contact)_posted=true/.test(location.search);
    var csuccess = root.querySelector('[data-bis-csuccess]');
    if (csuccess) csuccess.hidden = !posted;
    if (posted) {
      var pend = null;
      try { pend = JSON.parse(sessionStorage.getItem(PENDING) || 'null'); } catch (err) { pend = null; }
      try { sessionStorage.removeItem(PENDING); } catch (err) { /* ignore */ }
      if (pend && pend.vid) {
        root.dataset.variantId = pend.vid;
        subscribed[pend.vid] = true;
      }
      paint();
      root.hidden = false;
      open(true);
      showOk(true, pend && pend.email, (pend && pend.title) || (current() || {}).title);
    }
  }

  function boot() {
    document.querySelectorAll('[data-bis]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
